export const Languages = ['en', 'vi'];
